
import { useState } from 'react';
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Tables } from "@/integrations/supabase/types";

type Quote = Tables<'quotes'>;

export const useQuotePaymentGenerator = (quotes: Quote[], onQuoteUpdate?: () => void) => {
  const [generatingPayment, setGeneratingPayment] = useState<string | null>(null);

  const generatePaymentLink = async (quoteId: string) => {
    setGeneratingPayment(quoteId);
    try {
      const quote = quotes.find(q => q.id === quoteId);
      if (!quote?.quoted_amount) {
        toast.error('Quote amount not found');
        return;
      }

      console.log('[PAYMENT-GENERATION] Starting payment link generation', { quoteId, amount: quote.quoted_amount });

      const { data, error } = await supabase.functions.invoke('generate-payment-link', {
        body: {
          quoteId: quoteId,
          amount: quote.quoted_amount,
          currency: quote.currency || 'ZAR',
          provider: 'stripe'
        }
      });

      if (error) {
        console.error('[PAYMENT-GENERATION] Edge function error:', error);
        toast.error(`Failed to generate payment link: ${error.message}`);
        return;
      }

      if (data?.success) {
        console.log('[PAYMENT-GENERATION] Payment link generated successfully', data);
        toast.success('Payment link generated and sent to customer!');
        onQuoteUpdate?.();
      } else {
        console.error('[PAYMENT-GENERATION] Payment link generation failed:', data);
        const errorMessage = data?.error || 'Unknown error occurred';
        toast.error(`Failed to generate payment link: ${errorMessage}`);
      }
    } catch (error) {
      console.error('[PAYMENT-GENERATION] Exception during payment link generation:', error);
      toast.error(`Failed to generate payment link: ${error.message}`);
    } finally {
      setGeneratingPayment(null);
    }
  };

  return {
    generatingPayment,
    generatePaymentLink
  };
};
